export const DEFAULT_SCROLL_DELAY = 250;